var exports = {
  "j0": "DirectMessageLayout.module__dmLayoutContainer___ZTIybj",
  "eN": "DirectMessageLayout.module__dmLayoutContainerFullscreen___ZTIybj",
  "Il": "DirectMessageLayout.module__dmListColumn___ZTIybj",
  "qy": "DirectMessageLayout.module__contentColumn___ZTIybj",
  "$f": "DirectMessageLayout.module__contentColumnFullscreen___ZTIybj",
  "YE": "DirectMessageLayout.module__contentInner___ZTIybj",
  "jk": "DirectMessageLayout.module__contentInnerFullscreen___ZTIybj",
};

module.exports = exports;
